import React from 'react';
import { Grid, Typography } from '@mui/material';
import { InputField, LockeableInputField, EmailField, NumberField } from '../../FormFields';
import { useFormikContext } from 'formik';

export default function PersonDataForm(props) {
    const { setFieldValue, values } = useFormikContext();
    const {
        formField: {
            firstname,
            lastname,
            document,
            areaPhone,
            phoneNumber,
            areaCellPhone,
            cellPhoneNumber,
            email,
            emailConfirmation
        }
    } = props;

    return (
        <React.Fragment>
            <Typography variant="h6" gutterBottom>
                Datos Personales
            </Typography>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                    <NumberField name={document.name} label={document.label} maxSize={8} fullWidth />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <LockeableInputField name={lastname.name} label={lastname.label} fullWidth maxSize={100} />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <LockeableInputField name={firstname.name} label={firstname.label} fullWidth maxSize={100} />
                </Grid>
                <Grid item xs={5} sm={2}>
                    <NumberField name={areaPhone.name} label={areaPhone.label} maxSize={5} placeholder="Sin 0" fullWidth />
                </Grid>
                <Grid item xs={7} sm={4}>
                    <NumberField name={phoneNumber.name} label={phoneNumber.label} maxSize={12} fullWidth />
                </Grid>
                <Grid item xs={5} sm={2}>
                    <NumberField name={areaCellPhone.name} label={areaCellPhone.label} maxSize={5} placeholder="Sin 0" fullWidth />
                </Grid>
                <Grid item xs={7} sm={4}>
                    <NumberField name={cellPhoneNumber.name} label={cellPhoneNumber.label} placeholder="Sin 15" maxSize={12} fullWidth />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <EmailField name={email.name} label={email.label} fullWidth />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <EmailField name={emailConfirmation.name} label={emailConfirmation.label} fullWidth />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}